import React from 'react';
import ProductCard from './ProductCard';

const ProductList = ({ products, className = "w-full max-w-md mx-auto px-4 py-4 pb-28" }) => {
  return (
    <div className={className}>
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}

      {products.length === 0 && (
        <div className="text-center py-10 text-gray-400 col-span-full">
          <p>No items found</p>
        </div>
      )}
    </div>
  );
};

export default ProductList;
